'use strict';

/**
 * lodash template function
 * @param tmpl
 * @param params
 */
var render = function (tmpl, params) {
    if (typeof render[tmpl] !== 'function') {
        render[tmpl] = _.template(document.getElementById(tmpl).innerHTML);
    }
    return render[tmpl](params)
};
(function ($) {
    $.render = render;
    $.showModal = function (content, css) {
        $.fancybox.open('<div class="' + css + '">' + content + '</div>');
    };
    // Input Filter
    $.fn.inputFilter = function (inputFilter) {
        this.each(function (index) {
            let _this = $(this);
            if(typeof _this.data('inputFilter') === "undefined") {
                _this.data('inputFilter', true);
                _this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
                    if (inputFilter(this)) {
                        this.oldValue = this.value;
                        this.oldSelectionStart = this.selectionStart;
                        this.oldSelectionEnd = this.selectionEnd;
                    } else if (this.hasOwnProperty("oldValue")) {
                        this.value = this.oldValue;
                        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                    }
                });
            }
        });
        return this;
    };
})(jQuery);
